import moment from 'moment';
import {PICKUP, ASAP, DROPOFF} from '../../OrderSetting/orderSettingTypes';
import {
  timesAvailable,
  DELIVERY,
} from '../../OrderSetting/OrderSettingModal/utils/helper';

export const compareTime = (
  orderTime,
  interPickUpDetails,
  deliveryDetails,
  orderType,
  availableTimes,
  dateTimeToShow,
  dropOffDetails
) => {
  if (!orderTime.radioValue.value || orderTime.radioValue.value === ASAP) {
    const selectedDateTime = {
      dateTime: {
        date: {value: new Date().toString()},
      },
    };

    // const minPrepTime =
    //   orderType === PICKUP
    //     ? interPickUpDetails.settings.min_pickup_time
    //     : orderType === DROPOFF
    //     ? dropOffDetails.settings.min_drop_off_time
    //     : deliveryDetails.settings.min_delivery_time;

    if (orderType === PICKUP && !interPickUpDetails.accepting_orders) return false;

    if (orderType === DROPOFF && !dropOffDetails.accepting_orders) return false;

    if (
      orderType === DELIVERY &&
      !deliveryDetails.deliveryBusiness.accepting_orders
    )
      return false;

    if (
      availableTimes && availableTimes.length &&
      moment(availableTimes[0].order_start_time, 'h:mm A').isAfter(
        moment(),
        'minutes'
      )
    )
      return false;

    return true;
  } else {
    let currentTime;
    if (orderType === PICKUP) {
      currentTime = moment()
        .add(interPickUpDetails.settings.min_pickup_time, 'minutes')
        .format('YYYY-MM-DD HH:mm');
    } else if (orderType === DROPOFF) {
      currentTime = moment()
        .add(dropOffDetails.settings.min_drop_off_time, 'minutes')
        .format('YYYY-MM-DD HH:mm');
    } else {
      currentTime = moment()
        .add(deliveryDetails.deliveryBusiness.settings.min_delivery_time, 'minutes')
        .format('YYYY-MM-DD HH:mm');
    }
    let finalOrderDate = moment(
      dateTimeToShow.value,
      'ddd MMM DD YYYY LT'
    ).format('YYYY-MM-DD HH:mm');

    return moment(finalOrderDate).isSameOrAfter(currentTime);
  }
};

export {compareTime as isOrderTimeValid};
